import script from "./PreviewFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./PreviewFooter.vue?vue&type=script&setup=true&lang=ts"

import "./PreviewFooter.vue?vue&type=style&index=0&id=12e551fc&lang=scss"

const __exports__ = script;

export default __exports__